var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.business)?_c('div',_vm._l((_vm.mainChunks),function(chunk,index){return _c('PdfChunkRenderer',{key:index,ref:`chunkRenderer-${index}`,refInFor:true,attrs:{"chunk-data":chunk,"business":_vm.business,"logo":_vm.logo,"keymaster":_vm.keymaster}})}),1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }